import React from 'react';
import ReactDOM from 'react-dom';
import profileLoader from '../animations/profileLoader.json';
import Animation from './Animation';

const FullScreenLoader = () => {
  if (typeof document === 'undefined') return null;

  return ReactDOM.createPortal(
    <div
      style={{
        position: 'fixed',
        left: 0,
        top: 0,
        width: '100%',
        height: '100%',
        background: 'rgba(255, 255, 255, 0.5)',
        zIndex: 99999,
      }}
    >
      <div
        style={{
          position: 'absolute',
          left: '50%',
          top: '50%',
          transform: 'translate(-50%,-50%)',
        }}
      >
        <Animation width={150} animation={profileLoader} />
      </div>
    </div>,
    document.body
  );
};

export default FullScreenLoader;
